<template>
  <div class="download">
    <div class="download__con">
      <div
        :key="(item, index)"
        v-for="(item, index) in items"
        class="download__con--item"
      >
        <p class="download__con--item-title">{{ item.title }}</p>
        <img
          class="download__con--item-img"
          :src="item.image"
          :alt="item.image"
        />
        <p class="download__con--item-dec" v-html="item.description"></p>
        <a class="download__con--item-link" :href="item.link">دانلود</a>
      </div>
      <div class="pagination-con">
        <paginate
          v-model="pagee"
          :page-count="page"
          :click-handler="clickCallback"
          :prev-text="'قبلی'"
          :next-text="'بعدی'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  data() {
    return {
      pagee: 0,
      page: 0,
      items: [],
    };
  },
  created() {
    var that = this;
    that.$store.state.load = true;
    if (sessionStorage.getItem("dpage")) {
    } else sessionStorage.setItem("dpage", 1);
    that.pagee = parseInt(sessionStorage.getItem("dpage"));
    $.ajax({
      url:
        that.$store.state.url +
        "api/v1/teaching/download/?page=" +
        sessionStorage.getItem("dpage"),
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.$store.state.load = false;
        // that.pagee = data.count;
        that.page = data.lastPage;
        that.items = data.results;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        scroll(0, 0);
      },
    });
  },
  mounted() {},
  computed: {},
  components: {
    Paginate,
  },
  destroyed() {
    sessionStorage.setItem("dpage", "");
  },
  methods: {
    clickCallback(pageNum) {
      var that = this;
      this.$store.state.load = true;
      sessionStorage.setItem("dpage", parseInt(pageNum));
      $.ajax({
        url:
          that.$store.state.url + "api/v1/teaching/download/?page=" + pageNum,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.$store.state.load = false;
          // that.pagee = data.count;
          // that.page = data.lastPage;
          that.items = data.results;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          scroll(0, 0);
        },
      });
    },
  },
};
</script>
<style lang="scss">
.download {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10em;
  &__con {
    width: 55%;
    height: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    @media screen and (max-width: 1100px) {
      width: 85%;
    }
    @media screen and (max-width: 900px) {
      width: 90%;
    }
    &--item {
      padding: 2em;

      border-radius: 8px;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.164);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      background: var(--main-color);
      margin-bottom: 1em;
      //   border-bottom: 1px solid gray;
      //   height: 800px;
      //   background: red;
      //   overflow-x: hidden;
      //   overflow-y: scroll;
      &-title {
        // font-family: "lalezar";
        font-size: 1.5em;
        margin-bottom: 0.5em;
        color: var(--main-color);
        // text-shadow: 0 0 1px black;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--sub-color);
        border-radius: 8px;
        padding: 0.5em;
      }
      &-img {
        width: 300px;
        height: 300px;
        margin-bottom: 1em;
        // padding: 1em;
        // border: 1px solid black;
        border-radius: 8px;
        box-shadow: 0 0 1px black;
      }
      &-dec {
        z-index: 0;
        direction: rtl;
        margin-bottom: 1em;
        overflow-x: hidden;
        max-height: 300px;
        scrollbar-width: thin;
        scrollbar-color: var(--bg-color) var(--main-color);
        padding: 1em;
        width: 100%;
        @media screen and (max-width: 500px) {
          font-size: 0.7em;
        }
      }
      &-link {
        background: greenyellow;
        color: gray;
        width: 30%;
        padding: 0.75em;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        border-radius: 5px;
        margin-bottom: 1em;
        margin-top: 1em;
      }
    }
  }
}
.pagination-con {
  width: 100%;
}
.pagination {
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  // background: red;
  // padding: 1.5em 20em;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  // background: var(--bg-color);
  li {
    margin: 0 4px;
    padding: 0;
    list-style: none outside none;
    line-height: 5px;
    width: 100%;
    // background: chartreuse;
    a {
      border-radius: 3px;
      // background: var(--bg-color);
      // color: var(--font-color);
      // padding: 1em
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.9em;
      @media screen and (max-width: 500px) {
        font-size: 0.5em;
      }
    }
  }
  .active {
    color: var(--main-color);
    background: var(--sub-color);
  }
}
.page-item {
  border-radius: 3px;
  background: var(--bg-color);
  color: var(--font-color);
  // padding: 1em
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/download/download.vue